/**
 * Meta
 */
import React from 'react';
import { Helmet } from 'react-helmet';
/**
 * Component that handles meta data.
 *
 * - https://ogp.me/
 * - https://developer.twitter.com/en/docs/tweets/optimize-with-cards/overview/markup
 * - https://developer.twitter.com/en/docs/tweets/optimize-with-cards/guides/getting-started
 */
var Meta = function (props) {
    var children = props.children, title = props.title, description = props.description, keywords = props.keywords, ogSiteName = props.ogSiteName, ogType = props.ogType, ogTitle = props.ogTitle, ogUrl = props.ogUrl, ogImage = props.ogImage, twitterCard = props.twitterCard, twitterTitle = props.twitterTitle, twitterImage = props.twitterImage, _a = props.ogDescription, ogDescription = _a === void 0 ? description : _a, _b = props.twitterDescription, twitterDescription = _b === void 0 ? description : _b, htmlAttributes = props.htmlAttributes, contentId = props.contentId;
    var renderOgImage = function (image) {
        var ogImages;
        if (typeof image === 'string') {
            ogImages = [image];
        }
        else {
            ogImages = image;
        }
        return ogImages.map(function (img) {
            return React.createElement("meta", { property: "og:image", key: img, content: img });
        });
    };
    // prettier-ignore
    return (React.createElement(Helmet, { htmlAttributes: htmlAttributes },
        title && React.createElement("title", null, title),
        description && React.createElement("meta", { name: "description", content: description }),
        keywords && React.createElement("meta", { name: "keywords", content: keywords }),
        ogSiteName && React.createElement("meta", { property: "og:site_name", content: ogSiteName }),
        ogType && React.createElement("meta", { property: "og:type", content: ogType }),
        (ogTitle || title) && React.createElement("meta", { property: "og:title", content: ogTitle || title }),
        ogUrl && React.createElement("meta", { property: "og:url", content: ogUrl }),
        (ogDescription) && React.createElement("meta", { property: "og:description", content: ogDescription }),
        ogImage && renderOgImage(ogImage),
        twitterCard && React.createElement("meta", { name: "twitter:card", content: twitterCard }),
        twitterCard && twitterTitle && React.createElement("meta", { name: "twitter:title", content: twitterTitle }),
        twitterCard && (twitterDescription) && React.createElement("meta", { name: "twitter:description", content: twitterDescription }),
        twitterCard && twitterImage && React.createElement("meta", { name: "twitter:image", content: twitterImage }),
        contentId && React.createElement("meta", { name: "pageid", content: contentId }),
        children));
};
export default Meta;
